import Clickable from 'atoms/Clickable/Clickable';
import Stack from 'atoms/Layout/Stack/Stack';
import styled, { css } from 'styled-components';

const visibleStyles = css`
  opacity: 1;
  visibility: visible;
`;

export const BaseModalContainer = styled(Stack)`
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  opacity: 0;
  visibility: hidden;
  z-index: 110;
  transition: all 500ms ease-in-out;

  &.visible {
    ${visibleStyles}
  }
`;

interface BaseModalContentProps {
  $width: number | string;
}

export const BaseModalContent = styled.div<BaseModalContentProps>`
  position: relative;
  max-width: ${({ $width }) => (typeof $width === 'number' ? `${$width}px` : $width)};
  width: 100%;
  z-index: 111;
`;

export const BaseModalCloseButton = styled(Clickable)`
  position: absolute;
  top: 18px;
  right: 18px;
  z-index: 10;
`;
